import dashboardImg from '../../assets/illustration-dashboard.png'
import { Content } from './styles'

export function DashBoard() {
  return (
    <Content>
      <img src={dashboardImg} alt="Dashboard" />
    </Content>
  )
}